module.exports = __webpack_public_path__ + "img/indexIconac.c41bbaf9.png";